import { useCallback } from "react";

import { LoaderCircle, SearchIcon } from "lucide-react";

import { Input } from "@/components/ui/input";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  loading: boolean;
  placeholder: string;
}

export function SearchInput({
  value,
  onChange,
  loading,
  placeholder,
}: SearchInputProps) {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.value);
    },
    [onChange],
  );
  return (
    <div className="relative">
      <Input
        type="text"
        name="search"
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        className="px-10 h-12 text-md shadow-none border font-normal"
      />
      <SearchIcon className="absolute pointer-events-none left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
      {loading && (
        <LoaderCircle className="absolute pointer-events-none right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400 animate-spin" />
      )}
    </div>
  );
}
